import { JetView } from 'webix-jet';
import { devConfig, countries, profile, cashDesks, agentList } from 'config/config';

/**
 * Class representing the FilterPromotionalCodesView.
 * @extends JetView
 */
export default class FilterPromotionalCodesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Left section of the filter form
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Id', // User ID input
                    type: 'number',
                    label: _("<span class='icon-drivers-license-o'></span> ID Usuario"),
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility
                    css: 'prm-filterByUser',
                    labelPosition: 'top',
                    placeholder: _('ID Usuario'),
                },
                {
                    view: 'text',
                    name: 'LinkId', // Link ID input
                    label: _('LinkId'),
                    labelPosition: 'top',
                    placeholder: _('LinkId'),
                },
            ],
        };

        // Center left section of the filter form
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Name', // User Name input
                    label: "<span class='icon-user'></span>" + _('Nombre'),
                    labelPosition: 'top',
                    placeholder: _('Nombre'),
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility
                    css: 'prm-filterByUser',
                },
                {
                    view: 'text',
                    name: 'Code', // Promotional code input
                    label: _('Código'),
                    labelPosition: 'top',
                    placeholder: _('Código'),
                },
            ],
        };

        // Center right section of the filter form
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text',
                    name: 'Login', // User login input
                    label: _('Login'),
                    labelPosition: 'top',
                    placeholder: _('Login'),
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility
                    css: 'prm-filterByUser',
                },
                {
                    view: 'text',
                    name: 'CreatedLocalDate', // Date picker for creation date
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true,
                    label: _("<span class='webix_icon icon-calendar'></span> Fecha de Creación"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                },
            ],
        };

        // Right section of the filter form
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect',
                    name: 'IsActivate', // Activation status selection
                    label: _("<span class='icon-state'></span> Estado"),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: '',
                    options: [
                        { id: '0', value: _('Todos') }, // All option
                        { id: 'A', value: _('Activo') }, // Active option
                        { id: 'I', value: _('Inactivo') }, // Inactive option
                    ],
                },
            ],
        };

        // Upper section containing the filter inputs
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [left, center_left, center_right, right],
                },
            ],
        };

        // Buttons for actions
        const buttons = {
            margin: 5,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Añadir Código'), // Add code button
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        this.app.callEvent('addCode:button', [{}]); // Event to add code
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Clear button
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clear form inputs
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Consult button
                    hotkey: 'enter', // Enter key shortcut
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('promotionalCodes:filter', [filterdata]); // Event to filter promotional codes
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
